import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/noteItem/noteItem.pug?vue&type=template&id=5cbbfc4a&scoped=true&lang=pug&external"
import script from "./noteItem.view.vue?vue&type=script&lang=ts"
export * from "./noteItem.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/convocation/views/convocationDetail/noteItem/noteItem.scss?vue&type=style&index=0&id=5cbbfc4a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbbfc4a",
  null
  
)

export default component.exports